export default __webpack_public_path__ + "static/media/inex4.25bbb4e7.svg";